<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'

import { getAuthXToken, getLocalUserDeviceToken, authorizeRedirectUri } from '@/services/auth'
import { getDeviceKey } from '@/services/trusted-device/trusted-device-store'
import { isTrustedDeviceEnrollmentEnabled } from '@/services/trusted-device/is-trusted-device-enrollment-enabled'
import { useVerifyTrustedDeviceChallenge } from '@/services/trusted-device/use-verify-trusted-device-challenge'
import { useRoute, router } from '../../router'
import { modifyUrlQuery } from './modify-url-query'

const { useState: useUserStoreState } = createNamespacedHelpers('User')
const { useState: useLoginDomainStoreState } = createNamespacedHelpers('LoginDomain')

export default defineComponent({

  name: 'AuthorizePage',

  setup() {

    const { tenant } = useLoginDomainStoreState(['tenant'])
    const { trustedDeviceChallengeId } = useUserStoreState(['trustedDeviceChallengeId'])
    const { verify } = useVerifyTrustedDeviceChallenge()

    const currentRoute = useRoute()

    const getRedirectUri = (): string => {
      return currentRoute.value?.query.redirectUri as string
    }

    const authorize = async () => {

      try {

        const token = getAuthXToken()

        if (token && !trustedDeviceChallengeId.value && isTrustedDeviceEnrollmentEnabled(token.payload.email, token.payload.partnerCode)) {
          const device = await getDeviceKey(token.payload.email).catch(() => null)
          if (device) {
            await verify(device.deviceId, device.privateKey, token.value).catch(() => null)
          }
        }

        const deviceIdParams = trustedDeviceChallengeId.value
          ? { authxDeviceChallengeId: trustedDeviceChallengeId.value }
          : {}

        const redirectUri = modifyUrlQuery(getRedirectUri(), {
          userDeviceToken: getLocalUserDeviceToken(),
          ...deviceIdParams,
        })

        await authorizeRedirectUri(tenant.value, redirectUri)

      } catch (error) {

        router.replace({ name: 'Root' })

      }
    }

    onMounted(async () => {
      await authorize()
    })

  },

})

</script>

<template>
  <div class="logout">
    <sm-loader />
  </div>
</template>

<style lang="scss" scoped>
.loader {
  @apply min-h-screen;
}
.logout {
  @apply flex justify-center items-center min-h-screen;
}
</style>
